module.exports = __webpack_public_path__ + "img/emailicon.428fd23c.png";